const getFilterValue = value => {
  // To be updated with future filter options
  switch (value) {
    case 'not':
      return false;
    case 'on':
      return true;
    default:
      return true;
  }
};

const buildCheckboxFilters = checkboxFilters =>
  checkboxFilters.reduce((acc, checkboxFilter) => {
    if (typeof checkboxFilter === 'string') acc.push({ match: { [checkboxFilter]: true } });
    else {
      const filterValue = getFilterValue(checkboxFilter[1]);
      acc.push({ match: { [checkboxFilter[0]]: filterValue } });
    }
    return acc;
  }, []);

export default buildCheckboxFilters;
